import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Marker } from 'google-maps-react';

import GoogleApiWrapper from '../../common/MapContainer/MapContainer';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import ErrorScreen from '../../common/ErrorScreen/ErrorScreen';

import { StyledOfficeMap } from './styles/StyledOfficeMap';


class OfficeMap extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.isLoading !== nextProps.isLoading) {
      return true;
    }
    if (this.props.status !== nextProps.status) {
      return true;
    }
    return false;
  }

  render() {
    const { 
      isLoading,
      status,
      address, name, 
      lat, lng,
    } = this.props;

    if (isLoading) {
      return (
        <StyledOfficeMap>
          <div className="home-map-container">
            <LoadingSpinner />
          </div>
        </StyledOfficeMap>  
      );
    }

    if (!status) {
      return (
        <StyledOfficeMap>
          <div className="home-map-container">
            <ErrorScreen />
          </div>
        </StyledOfficeMap>  
      );
    }

    const markers = (
      <Marker 
        title={name + '\n' + address}
        name={name}
        position={{lat: lat, lng: lng}}
      />
    );
    
    return (
      <div>
        <StyledOfficeMap>
          <GoogleApiWrapper 
            initCenter={{lat: lat, lng: lng}}
            initZoom={14}
            centerTo={{lat: lat, lng: lng}}
            markers={markers}
          />
        </StyledOfficeMap>
      </div>
    );
  }
}


OfficeMap.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  status: PropTypes.bool.isRequired,
  address: PropTypes.string,
  name: PropTypes.string,
  lat: PropTypes.number,
  lng: PropTypes.number,
};


export default OfficeMap;


// WEBPACK FOOTER //
// ./src/components/OfficeMap/OfficeMap.js